import React, { useState, useRef, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  useLocation
} from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/mousewheel';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';

// Компонент ProgressiveImage для прогрессивной загрузки изображений (эффект размытия)
function ProgressiveImage({ src, alt, style, disableContextMenu, ...props }) {
  const [loaded, setLoaded] = useState(false);
  return (
    <img
      src={src}
      alt={alt}
      style={{
        ...style,
        filter: loaded ? 'none' : 'blur(20px)',
        transition: 'filter 0.5s ease-out'
      }}
      onLoad={() => setLoaded(true)}
      onContextMenu={disableContextMenu ? (e) => e.preventDefault() : undefined}
      {...props}
    />
  );
}

function BackgroundVideo({ className }) {
  const videoRef = useRef(null);
  useEffect(() => {
    const video = videoRef.current;
    const handleEnded = () => {
      video.currentTime = 0;
      video.play();
    };
    video.addEventListener('ended', handleEnded);
    video.onloadeddata = () => {
      video.play().catch((err) => console.log('Error playing video:', err));
    };
    return () => {
      video.removeEventListener('ended', handleEnded);
    };
  }, []);
  return (
    <video
      ref={videoRef}
      className={`video-background visible ${className}`}
      autoPlay
      muted
      playsInline
      webkit-playsinline="true"
      preload="auto"
      loop={false}
    >
      <source
        src="https://res.cloudinary.com/drnptlojo/video/upload/f_auto,q_auto/v1738891275/c55kpsifwmpacldmgsut.mp4"
        type="video/mp4"
      />
      Ваш браузер не поддерживает видео.
    </video>
  );
}

function Header() {
  return (
    <header className="site-header">
      <div className="header-inner">
        <NavLink
          to="/"
          end
          className={({ isActive }) =>
            isActive ? 'nav-btn active' : 'nav-btn'
          }
        >
          Home
        </NavLink>
        <NavLink
          to="/music"
          className={({ isActive }) =>
            isActive ? 'nav-btn active' : 'nav-btn'
          }
        >
          Music
        </NavLink>
        <div
          className="logo-container"
          onClick={() => (window.location.href = '/')}
          style={{ cursor: 'pointer' }}
        >
          <img src="/revetglogo.png" alt="Логотип" className="logo" />
        </div>
        <NavLink
          to="/video"
          className={({ isActive }) =>
            isActive ? 'nav-btn active' : 'nav-btn'
          }
        >
          Video
        </NavLink>
        <NavLink
          to="/merch"
          className={({ isActive }) =>
            isActive ? 'nav-btn active' : 'nav-btn'
          }
        >
          Merch
        </NavLink>
      </div>
    </header>
  );
}

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="social-icons">
          <a
            href="https://www.instagram.com/revetg_/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/instagram.png"
              alt="Instagram"
            />
          </a>
          <a
            href="https://www.youtube.com/@revetg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/youtube-play.png"
              alt="YouTube"
            />
          </a>
          <a
            href="https://t.me/revetg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/telegram-app.png"
              alt="Telegram"
            />
          </a>
          <a
            href="https://open.spotify.com/artist/2ZhIl5uiOEDnEyyz1s4aCp"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/spotify.png"
              alt="Spotify"
            />
          </a>
          <a
            href="https://soundcloud.com/revetgg"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/soundcloud.png"
              alt="SoundCloud"
            />
          </a>
          <a
            href="https://music.apple.com/at/artist/revetg/1480158868"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://img.icons8.com/ios-filled/50/ffffff/apple-music.png"
              alt="Apple Music"
            />
          </a>
        </div>
        <div className="footer-text">2025 REVETG</div>
      </div>
    </footer>
  );
}

function Home() {
  return (
    <>
      <BackgroundVideo className="visible" />
      <div className="home-overlay">
        <span className="guntherapy-text desk-version">
          guntherapy
          <span className="desk-space"></span>
          <br className="mobile-break" />
          out now
        </span>
        <span className="guntherapy-text mobile-version">out now</span>
      </div>
      <div className="tab-content">
        {/* Остальной контент, если нужен */}
      </div>
    </>
  );
}

// Хук для отслеживания ширины окна
function useWindowWidth() {
  const [width, setWidth] = useState(window.innerWidth);
  useEffect(() => {
    function handleResize() {
      setWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return width;
}

function Music() {
  const width = useWindowWidth();
  const isMobile = width < 768;

  const oldReleases = [
    {
      title: 'guntherapy',
      link: 'https://band.link/LbWr2',
      image: 'https://i.imgur.com/Y0CPRD1.jpeg'
    },
    {
      title: 'met gala',
      link: 'https://bfan.link/met-gala',
      image: 'https://i.imgur.com/t2GLX0E.jpg'
    },
    {
      title: 'be here',
      link: 'https://band.link/revetgbehere',
      image: 'https://i.imgur.com/A8BVehE.jpg'
    },
    {
      title: 'SS25',
      link: 'https://band.link/oRINs',
      image: 'https://i.imgur.com/Rhg2JEk.jpg'
    },
    {
      title: 'SS25 (Single)',
      link: 'https://band.link/ss25',
      image: 'https://i.imgur.com/3ooZI0z.jpg'
    }
  ];

  const newReleases = [
    {
      title: 'POP-UP',
      link: 'https://band.link/popupisopennow',
      image: 'https://i.imgur.com/UWFius7.png'
    },
    {
      title: '@QUIT',
      link: 'https://band.link/bWo5I',
      image: 'https://i.imgur.com/wp1xVQq.jpeg'
    },
    {
      title: '@ALYX',
      link: 'https://band.link/DbdRm',
      image: 'https://i.imgur.com/l0cbugj.png'
    }
  ];

  const allReleases = [...oldReleases, ...newReleases];
  const swiperRef = useRef(null);

  useEffect(() => {
    if (!isMobile && swiperRef.current && swiperRef.current.el) {
      const onWheel = (e) => {
        if (Math.abs(e.deltaY) > 50) {
          e.preventDefault();
          if (e.deltaY > 0) {
            swiperRef.current.slideNext();
          } else {
            swiperRef.current.slidePrev();
          }
        }
      };
      const swiperEl = swiperRef.current.el;
      swiperEl.addEventListener('wheel', onWheel);
      return () => {
        swiperEl.removeEventListener('wheel', onWheel);
      };
    }
  }, [isMobile]);

  if (isMobile) {
    return (
      <div className="tab-content music-tab-content">
        <div
          className="music-mobile"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            padding: '20px 0'
          }}
        >
          {allReleases.map((release, idx) => (
            <div
              key={idx}
              className="release-mobile"
              style={{
                marginBottom: '20px',
                width: '280px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <a
                href={release.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  color: '#fff',
                  textAlign: 'center'
                }}
              >
                <ProgressiveImage
                  src={release.image}
                  alt={release.title}
                  loading="lazy"
                  disableContextMenu={true}
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'contain',
                    transition: 'transform 0.3s',
                    marginBottom: '10px'
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = 'scale(1.05)')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = 'scale(1.0)')
                  }
                />
                <div style={{ fontSize: '16px' }}>{release.title}</div>
              </a>
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <div className="tab-content music-tab-content">
        <Swiper
          modules={[Navigation, Mousewheel]}
          simulateTouch={false}
          freeMode={{
            enabled: true,
            sticky: true,
            momentum: true,
            momentumRatio: 0.9,
            momentumVelocityRatio: 1.2,
            momentumBounce: false
          }}
          grabCursor={true}
          mousewheel={{
            forceToAxis: true,
            sensitivity: 2,
            invert: false,
            releaseOnEdges: false
          }}
          navigation={true}
          loop={true}
          slidesPerView={4}
          slidesPerGroup={1}
          centeredSlides={false}
          spaceBetween={20}
          speed={300}
          tabIndex={0}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          style={{
            width: '100%',
            height: '80vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 20px'
          }}
        >
          {allReleases.map((release, idx) => (
            <SwiperSlide
              key={idx}
              style={{
                width: '240px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <a
                href={release.link}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: 'none',
                  color: '#fff',
                  textAlign: 'center'
                }}
              >
                <ProgressiveImage
                  src={release.image}
                  alt={release.title}
                  loading="lazy"
                  disableContextMenu={true}
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'contain',
                    transition: 'transform 0.3s',
                    marginBottom: '10px'
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = 'scale(1.05)')
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = 'scale(1.0)')
                  }
                />
                <div style={{ fontSize: '16px' }}>{release.title}</div>
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  }
}

function Video() {
  // Объявляем состояния для каждого видео
  const [guntherapyLoaded, setGuntherapyLoaded] = useState(false);
  const [metGalaLoaded, setMetGalaLoaded] = useState(false);
  const [alyxLoaded, setAlyxLoaded] = useState(false);

  return (
    <div className="tab-content">
      {/* Новый клип "guntherapy" – теперь первый */}
      <div className="video-wrapper">
        <div className="video-container">
          {guntherapyLoaded ? (
            <iframe
              src="https://www.youtube.com/embed/vRHKAB7kvOY?autoplay=1"
              title="guntherapy"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="video-preview" onClick={() => setGuntherapyLoaded(true)}>
              <ProgressiveImage
                src="https://img.youtube.com/vi/vRHKAB7kvOY/hqdefault.jpg"
                alt="guntherapy"
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
              <div className="play-button"></div>
            </div>
          )}
        </div>
        <div className="video-caption">guntherapy</div>
      </div>

      {/* Второй клип – "met gala" */}
      <div className="video-wrapper">
        <div className="video-container">
          {metGalaLoaded ? (
            <iframe
              src="https://www.youtube.com/embed/Yr13s_mp-00?autoplay=1"
              title="met gala"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="video-preview" onClick={() => setMetGalaLoaded(true)}>
              <ProgressiveImage
                src="https://img.youtube.com/vi/Yr13s_mp-00/hqdefault.jpg"
                alt="met gala"
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
              <div className="play-button"></div>
            </div>
          )}
        </div>
        <div className="video-caption">met gala</div>
      </div>

      {/* Третий клип – "@ALYX" */}
      <div className="video-wrapper">
        <div className="video-container">
          {alyxLoaded ? (
            <iframe
              src="https://www.youtube.com/embed/72w7D73SnTE?autoplay=1"
              title="@ALYX"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          ) : (
            <div className="video-preview" onClick={() => setAlyxLoaded(true)}>
              <ProgressiveImage
                src="https://img.youtube.com/vi/72w7D73SnTE/hqdefault.jpg"
                alt="@ALYX"
                loading="lazy"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'cover'
                }}
              />
              <div className="play-button"></div>
            </div>
          )}
        </div>
        <div className="video-caption">@ALYX</div>
      </div>
    </div>
  );
}

function Merch() {
  return (
    <div className="tab-content">
      <div className="merch">
        <h2>Merch</h2>
        <p>Мерч будет доступен позже.</p>
      </div>
    </div>
  );
}

// Компонент Layout – фиксирует Header и Footer вне анимаций
function Layout({ children }) {
  return (
    <>
      <Header />
      <main style={{ flex: 1 }}>{children}</main>
      <Footer />
    </>
  );
}

// AppContent: здесь только основной контент (маршруты) анимируется,
// а Header и Footer остаются вне анимации благодаря Layout.
function AppContent() {
  const location = useLocation();
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (isFirstLoad) {
      setIsFirstLoad(false);
    }
  }, [location, isFirstLoad]);

  return (
    <div className="App">
      <Layout>
        <main style={{ flex: 1 }}>
          <AnimatePresence mode="wait">
            <Routes location={location}>
              <Route
                path="/"
                element={
                  <motion.div
                    initial={isFirstLoad ? {} : { opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Home />
                  </motion.div>
                }
              />
              <Route
                path="/music"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Music />
                  </motion.div>
                }
              />
              <Route
                path="/video"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Video />
                  </motion.div>
                }
              />
              <Route
                path="/merch"
                element={
                  <motion.div
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{ duration: 0.3 }}
                  >
                    <Merch />
                  </motion.div>
                }
              />
            </Routes>
          </AnimatePresence>
        </main>
      </Layout>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
